import { User, Users } from 'lucide-react'
import type { Assignee, ClaimedBy } from '../types'

interface AssigneeChipProps {
  assignee: Assignee
  claimedBy: ClaimedBy | null
}

/**
 * Kompaktowy chip pokazujący assignee:
 *  - User → "👤 Imię Nazwisko"
 *  - Group unclaimed → "👥 Nazwa zespołu · do wzięcia"
 *  - Group claimed → "👥 Nazwa zespołu · podjął Imię Nazwisko"
 */
export function AssigneeChip({ assignee, claimedBy }: AssigneeChipProps) {
  if (assignee.type === 'USER') {
    return (
      <span className="inline-flex items-center gap-1 rounded bg-blue-50 px-2 py-0.5 text-xs text-blue-900">
        <User className="h-3 w-3" />
        {assignee.userName}
      </span>
    )
  }
  return (
    <span className="inline-flex items-center gap-1 rounded bg-amber-50 px-2 py-0.5 text-xs text-amber-900">
      <Users className="h-3 w-3" />
      {assignee.group.label}
      {claimedBy ? (
        <span className="text-muted-foreground"> · podjął {claimedBy.userName}</span>
      ) : (
        <span className="font-medium text-amber-700"> · do wzięcia</span>
      )}
    </span>
  )
}
